(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var initAdvantagesAnimation = function initAdvantagesAnimation() {
  var items = Array.from(document.querySelectorAll('.about-us__advantages-item'));
  if (!items.length) {
    return;
  }
  var DELAY_STEP = 0.15; // sekundy między elementami

  items.forEach(function (item, index) {
    item.style.setProperty('--delay', "".concat(index * DELAY_STEP, "s"));
  });
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      } else {
        entry.target.classList.remove('is-visible');
      }
    });
  }, {
    threshold: 0.2
  });
  items.forEach(function (item) {
    return observer.observe(item);
  });
};
document.addEventListener('DOMContentLoaded', initAdvantagesAnimation);

},{}]},{},[1]);
